import type { BlockExport } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { Container } from "./ContainerBlock";
import { defaultData } from "./ContainerBlockDefaultData";
import { meta } from "./ContainerBlockMetaData";

export const ContainerBlock: BlockExport = {
  type: "component",
  Block: Container,
  imagePreview: {
    type: "icon",
    name: "24-builder-element-container",
    size: 24,
  },
  defaultData,
  meta,
};
